// extracted by mini-css-extract-plugin
module.exports = {"textareafooter":"LongTextArea_textareafooter__2LLYr","textAreaField":"LongTextArea_textAreaField__hk2cd"};